import React from 'react'
import { makeStyles } from '@material-ui/core/styles'
import ForgotPasswordCard from '../../components/ForgotPasswordCard'
import { useIntl } from 'react-intl'
import { Helmet } from 'react-helmet'

const useCustomStyles = makeStyles(() => ({
  forgotPage: {
    height: '100%',
    display: 'flex',
  },
}))

function ForgotPage() {
  const classes = useCustomStyles()
  const intl = useIntl()
  const pageTitle = intl.formatMessage({ id: 'page_title_forgot', defaultMessage: 'Forgot account | OCLC' })

  return (
    <div data-testid='forgot-password-page' className={classes.forgotPage}>
      <Helmet title={pageTitle} />
      <ForgotPasswordCard />
    </div>
  )
}

export default ForgotPage
